import { Box, CssBaseline, useMediaQuery } from '@mui/material';
import React, { Suspense, useContext, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import KenPrivateRoute from '../../Components/KenPrivateRoute';
import routes from '../../Constants/routes';
import { AuthContext } from '../../Context/authContext';
import { useTheme } from '@emotion/react';
import { SnackbarProvider } from 'notistack';
import { ErrorBoundary } from 'react-error-boundary';
import KenLoader from '../../Components/KenLoader';
import { PERMISSIONS, ROLES, TABLET_BREAKPOINT } from '../../Constants/constant';
import { useAppContext } from '../../Context/appContext';
import { ErrorFallback } from '../../Utils/ErrorBoundary';
import { getAxiosInstance, getConfig } from '../../Utils/apiServices';
import { SVGs, Images } from "../../Utils/Helpers/assetHelper";
const HomePage = React.lazy(() => import('../HomePage'));
const MenuAppBar = React.lazy(() => import('../../Components/MenuAppBar'));
const Login = React.lazy(() => import('../Auth/Login'));
const SignUp = React.lazy(() => import('../Auth/SignUp'));
const LoginOTP = React.lazy(() => import('../Auth/Login/LoginOTP'));
const VerifyNumber = React.lazy(() => import('../Auth/SignUp/VerifyNumber'));
const VerifyEmail = React.lazy(() => import('../Auth/SignUp/VerifyEmail'));
const VerifiedOTP = React.lazy(() => import('../Auth/SignUp/VerifiedOTP'));
const SideNavigation = React.lazy(() => import('../../Components/SideNavigation'));

export default function MainLayout() {
  const {
    state: { isAuthenticated },
  } = useContext(AuthContext);
  const query = new URLSearchParams(useLocation().search);
  const programSearch = query.get('search_program') || localStorage.getItem('programSearch');
  const {
    state: { isLoading = false },
    dispatch,
  } = useAppContext();

  const theme = useTheme();
  const screenSize = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobileScreen = useMediaQuery(theme.breakpoints.down(TABLET_BREAKPOINT));

  const location = useLocation();
  const isForm = location.pathname === '/form' || location.pathname === '/application';
  const isSearch = programSearch !== null && programSearch !== '' && programSearch !== undefined;
  const [open, setOpen] = React.useState(true);
  const [config, setConfig] = useState();
  const [swipeableDrawer, setSwipeableDrawer] = useState();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  React.useEffect(() => {
    getConfig()
      .then((res) => {
        dispatch({ type: 'updateConfig', value: res[0]?.config });
        dispatch({ type: 'updateLogo', value: Images.SidenavImg });
        getAxiosInstance(res);
        setConfig(res[0]?.config);
      })
      .catch((err) => {
        console.log('error in config', err);
      });
  }, []);

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Suspense fallback={ErrorFallback}>
      <div style={!isForm ? { height: '100%' } : {}}>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => {
            window.location.reload();
          }}
        >
          <SnackbarProvider autoHideDuration={5000}>
            <Box display={'flex'} height={'100%'}>
              <CssBaseline />
              {!config ? (
                <KenLoader />
              ) : (
                <>
                  {isLoading && <KenLoader />}
                  {isAuthenticated && !isForm && (
                    <>
                      <SideNavigation
                        open={open}
                        handleDrawerClose={handleDrawerClose}
                        handleDrawerOpen={handleDrawerOpen}
                        setSwipeableDrawer={setSwipeableDrawer}
                        swipeableDrawer={swipeableDrawer}
                        setOpen={setOpen}
                      />
                      <MenuAppBar open={open} handleDrawerOpen={handleDrawerOpen} setSwipeableDrawer={setSwipeableDrawer} />
                    </>
                  )}
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      margin: isMobileScreen ? '0px' : !isAuthenticated || isForm ? '0px' : screenSize ? '80px - 28px' : '80px 16px',
                      height: !isAuthenticated ? '100%' : 'calc(100% - 160px)',
                      width: isMobileScreen ? '100%' : undefined,
                      paddingTop: isMobileScreen ? '65px' : undefined,
                      //  Note: added following so for main screen the gird is splitted on 12 grid after subtracting side navbar
                      maxWidth: !isMobileScreen && isAuthenticated && !isForm ? (open ? 'calc(100% - 260px)' : 'calc(100% - 145px)') : undefined,
                    }}
                  >
                    <Routes>
                      <Route path={'/'} element={isSearch ? <Navigate to={`/courses?search_program=${programSearch}`} /> : <Navigate to="/home" />} />
                      <Route path={routes.login} element={isAuthenticated ? isSearch ? <Navigate to={`/courses?search_program=${programSearch}`} /> : <Navigate to="/home" /> : <Login />} />
                      <Route path={routes.signup} element={isAuthenticated ? isSearch ? <Navigate to={`/courses?search_program=${programSearch}`} /> : <Navigate to="/home" /> : <SignUp />} />
                      <Route path={routes.loginOTP} element={isAuthenticated ? isSearch ? <Navigate to={`/courses?search_program=${programSearch}`} /> : <Navigate to="/home" /> : <LoginOTP />} />
                      <Route path={routes.verifyNumber} element={isAuthenticated ? <Navigate to="/home" /> : <VerifyNumber />} />
                      <Route
                        path={routes.verifyEmail}
                        element={isAuthenticated ? isSearch ? <Navigate to={`/courses?search_program=${programSearch}`} /> : <Navigate to="/home" /> : <VerifyEmail />}
                      />
                      <Route path={routes.verifiedOTP} element={isAuthenticated ? <Navigate to="/home" /> : <VerifiedOTP />} />
                      <Route
                        exact
                        path={`/home`}
                        redirectTo="/login"
                        element={
                          <KenPrivateRoute id={PERMISSIONS[ROLES.APPLICANT].APP_HOME}>
                            <HomePage />
                          </KenPrivateRoute>
                        }
                      />
                    </Routes>
                  </Box>
                </>
              )}
            </Box>
          </SnackbarProvider>
        </ErrorBoundary>
      </div>
    </Suspense>
  );
}
